/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Role } from '@touchplan/common';
import { MatDialog } from '@angular/material/dialog';
import { RolesApi } from 'src/app/app-data/state/RolesApi';
import { AbstractAddEditColorItemComponent } from 'src/app/common/dialog-reusable/components/abstract-add-edit-color-item.component';

@Component({
	selector: 'add-edit-role',
	templateUrl: './add-edit-role.component.html',
	styleUrls: ['./add-edit-role.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddEditRoleComponent extends AbstractAddEditColorItemComponent<Role> {
	@Input() public rolesApi: RolesApi;

	constructor(protected dialog: MatDialog, protected builder: UntypedFormBuilder) {
		super(dialog, builder);
	}

	protected getColorFormControlName() {
		return 'color';
	}

	protected getColorFromModel(role: Role): string {
		return role.view.color ?? null;
	}

	protected valueForFormGroupPatchValue(role: Role, color: string): { [key: string]: any } {
		return {
			name: role.view.roleName,
			color,
		};
	}
}
